import { Injectable } from '@angular/core';
import { UserIdService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { InvoiceAdapter } from './invoice.adapter';
import {
  InvoiceRequestConfig,
  InvoicesRequestConfig,
  InvoicesStatusRequest,
  InvoiceStatusRequest,
} from './invoice.model';

import { ExcelDownload } from '../../../../core/models/excelDownload.model';

@Injectable()
export class InvoiceService {
  constructor(
    protected userIdService: UserIdService,
    private invoiceAdapter: InvoiceAdapter,
  ) {}

  getInvoices(invoicesRequestConfig: InvoicesRequestConfig): Observable<InvoicesStatusRequest> {
    return this.invoiceAdapter.getInvoices(invoicesRequestConfig);
  }

  getInvoice(orderRequestConfig: InvoiceRequestConfig): Observable<InvoiceStatusRequest> {
    return this.invoiceAdapter.getInvoice(orderRequestConfig);
  }
  exportInvoices(invoicesRequestConfig: InvoicesRequestConfig): Observable<ExcelDownload> {
    return this.invoiceAdapter.getInvoicesExport(invoicesRequestConfig);
  };

  exportInvoice(invoiceRequestConfig: InvoiceRequestConfig): Observable<ExcelDownload> {
    return this.invoiceAdapter.getInvoiceExport(invoiceRequestConfig);
  };
}
